import { render, staticRenderFns } from "./Sign2.vue?vue&type=template&id=311334fa&scoped=true&"
import script from "./Sign2.vue?vue&type=script&lang=js&"
export * from "./Sign2.vue?vue&type=script&lang=js&"
import style0 from "./Sign2.vue?vue&type=style&index=0&id=311334fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311334fa",
  null
  
)

export default component.exports